import { MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService } from "@azure/msal-angular";
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "@hub-env/environment";
import { FeatureFlagsService } from "@hub-services/feature-flags.service";
import { AuthService } from "./auth/auth.service";


export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function initializeMsalApp(
  msalService: MsalService,
  featureFlag: FeatureFlagsService,
  authService: AuthService,
) {
  return async () => {
    await msalService.instance.initialize();

    let redirectResult = null;
    try {
      redirectResult = await msalService.instance.handleRedirectPromise();

      if (redirectResult?.account) {
        msalService.instance.setActiveAccount(redirectResult.account);
      } else {
        const accounts = msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          msalService.instance.setActiveAccount(accounts[0]);
        }
      }
    } catch (error) {
      console.error('MSAL initialization error:', error);
      const accounts = msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        msalService.instance.setActiveAccount(accounts[0]);
      }
    }

    authService.initialize(redirectResult);
  };
}
export function MSALInstanceFactory(window: Window): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      knownAuthorities: [environment.b2cPolicies.authorityDomain],
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true,
      secureCookies: true,
    },
    system: {
      iframeHashTimeout: 10000,
      // allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // Built once at MSAL configuration time, keyed by API origin. Runtime-configured
  // origins must resolve before this factory runs; see environment.k8s.ts.
  protectedResourceMap.set(
    environment.API_URL,
    environment.apiConfig.scopes
  );
  if (environment.apiConfig.graphUri && environment.apiConfig.graphScopes) {
    protectedResourceMap.set(
      environment.apiConfig.graphUri,
      environment.apiConfig.graphScopes
    );
  }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [
        ...environment.apiConfig.scopes,
        // ...environment.apiConfig.graphScopes,
      ],
    },
    loginFailedRoute: '/access-denied',
  };
}
